const registerComponentsGloballyToNg = require('../../components/components-to-ng').default;
const reactAngularGlue = require("./reactAngularGlue");
const config = require('../../config').default;

const angularRequire = require('./angularRequire');
const dndLists = require('angular-drag-and-drop-lists')
const angular = require('angular');
const {addTemplatesToCache} = require("../../angularModules/requireTemplates");

var clientDashboardApp = angular.module('clientDashboardApp', [
  require('angular-resource'),
  angularRequire('angular-ui-router'),
  angularRequire('state-events'),
  require('angular-animate'),
  'ui.bootstrap',
  require('angular-sanitize'),
  angularRequire('ng-draggable'),
  angularRequire('angular-media-queries'),
  angularRequire('ng-file-upload'),
  angularRequire('angular-filter'),
  angularRequire('angular-breadcrumb'),
  angularRequire('ui-select'),
  angularRequire('angular-ui-select2'),
  angularRequire('angular-ui-ace'),
  'clientDashboardApp.reviewBuilder',
  'clientDashboardApp.admin',
  'clientDashboardApp.chatmeterAdmin',
  'clientDashboardApp.auth',
  'clientDashboardApp.common',
  'clientDashboardApp.httpUtil',
  'clientDashboardApp.localSearchAnalytics',
  'clientDashboardApp.socialScore',
  'ngAnimate',
  'react',
  'monospaced.elastic',
  'dndLists'
]);

angular.module('clientDashboardApp.common', [])

reactAngularGlue.install(clientDashboardApp);

addTemplatesToCache(clientDashboardApp);

registerComponentsGloballyToNg(clientDashboardApp);

clientDashboardApp
  .config(function ($stateProvider, $urlRouterProvider) {

  $stateProvider
    .state('snapshot', {
      url: '/snapshot?{groupId:string}',
      template: require('../../angularModules/snapshot/snapshot.html'),
      controller: 'SnapshotCtrl'
    })
    .state('localSearchAnalytics', {
      url: '/localSearchAnalytics?{groupId:string}&{reportRange:string}&{startDate}&{endDate}',
      template: require('../../angularModules/localSearchAnalytics/localSearchAnalytics.html'),
      controller: 'LocalSearchAnalyticsCtrl',
      reloadOnSearch : false,
      onEnter: ['locationService', '$stateParams', (locationService, $stateParams) => {
        if ($stateParams.groupId && $stateParams.groupId.substr(0, 4) !== 'all-') {  // For whatever reason, this gets in a fight w/ the index controller otherwise
          locationService.setSelectedGroupId($stateParams.groupId)      // TODO: Ideally, the location widget would be controlled by the route directly
        }
      }],
      params: {
        groupId: ['locationService', function(locationService) { return locationService.getSelectedGroupId() }],
      }
    })
    .state('listings', {
      url: '/listings',
      abstract: true,
      template: '<ui-view/>'
    })
    .state('listings.accuracy', {
      url: '/accuracy?{groupId:string}&{reportType:string}&{reportRange:string}&{startDate:string}&{endDate:string}&{range:string}&{providers}&{localSearchAnalyticsProvider:string}&{showGroups}',
      template: require('../../angularModules/listings/listingAccuracy/listingAccuracy.html'),
      controller: 'ListingAccuracy',
      reloadOnSearch: false
    })
    .state('listings.summary', {
      url: '/summary?{groupId:string}&{providers}',
      template: require('../../angularModules/listings/listingSummary.html'),
      controller: 'ListingCtrl',
      reloadOnSearch: false
    })
    .state('listings.optimization', {
      url: '/listingOptimization?{groupId:string}&{providers}',
      template: require('../../angularModules/listings/listingOptimization.html'),
      controller: 'ListingCtrl',
      reloadOnSearch: false
    })
    .state('listings.missing', {
      url: '/missingListings?{groupId:string}&{providers}',
      template: require('../../angularModules/listings/missingListings.html'),
      controller: 'ListingCtrl',
      reloadOnSearch: false
    })
    .state('listings.duplicates', {
      url: '/duplicateListings?{groupId:string}&{providers}',
      template: require('../../angularModules/listings/duplicateListings.html'),
      controller: 'ListingCtrl',
      reloadOnSearch: false
    })
    .state('listings.searchAnalytics', {
      url: '/searchAnalyticsReport?{groupId:string}&{reportRange:string}&{startDate}&{endDate}&{range:string}&{providers}&{localSearchAnalyticsProvider:string}&{showGroups}',
      template: require('../../angularModules/localSearchAnalytics/localSearchAnalytics.html'),
      controller: 'LocalSearchAnalyticsCtrl',
      reloadOnSearch : false,
      onEnter: ['locationService', '$stateParams', (locationService, $stateParams) => {
        if ($stateParams.groupId && $stateParams.groupId.substr(0, 4) !== 'all-') {  // For whatever reason, this gets in a fight w/ the index controller otherwise
          locationService.setSelectedGroupId($stateParams.groupId)      // TODO: Ideally, the location widget would be controlled by the route directly
        }
      }],
      params: {
        groupId: ['locationService', function(locationService) { return locationService.getSelectedGroupId() }],
        localSearchAnalyticsProvider: ''
      }
    })
    .state('user.account_update', {
      url: '/account/update',
      template: require('../../angularModules/admin/updateAccount.html'),
      controller: 'UpdateAccountCtrl'
    })
    .state('admin', {
      url: '/admin',
      abstract: true,
      template: '<ui-view/>'
    })
    .state('admin.location', {
      url: '/location/:locationId',
      abstract: true,
      template: '<ui-view/>'
    })
    .state('admin.location_upload', {
      url: '/location/upload',
      template: require('../../angularModules/admin/locationUpload/locationUploader.html'),
      controller: 'LocationUploadCtrl'
    })
    .state('scores', {
      url: '/scores',
      abstract: true,
      template: '<ui-view/>'
    })
    .state('scores.storeComparison', {
      url: '/storeComparison',
      template: require('../../angularModules/scores/storeComparison/scoreStoreComparison.html'),
      controller: 'ScoreStoreComparisonCtrl',
      reloadOnSearch: false,
      redirectTo: 'scores.storeComparison.locations'
    })
    .state('scores.storeComparison.locations', {
      url: '/locations?{groupId:string}&{end:string}&{start:string}',
      template: require('../../angularModules/scores/storeComparison/locationsList.html'),
      params: {showGroups: false},
      reloadOnSearch: true

    }).state('scores.storeComparison.groups', {
      url: '/groups?{groupId:string}&{end:string}&{start:string}',
      template: require('../../angularModules/scores/storeComparison/groupsList.html'),
      params: {showGroups: true},
      reloadOnSearch: true,
    })
    .state('scores.summary', {
      url: '/summary?{groupId:string}&{end:string}&{start:string}',
      template: require('../../angularModules/scores/summary/scoreSummary.html'),
      controller: 'ScoreSummaryCtrl',
      reloadOnSearch: false,
    })
    .state('404', {
      template: require('../../views/404.html'),
      controller: () => console.log('404 mounted')
    })
})
  // send template requests to the asset host instead of api
  .config(function($provide) {
    $provide.decorator('$templateRequest', function($http, $templateCache, $q, $delegate) {
      // Return a function that will be
      // called when a template needs to be fetched
      return function(templateUrl) {
        // Check if the template is already in cache
        var tpl = $templateCache.get(templateUrl);
        if (tpl !== undefined) {
          return $q.resolve(tpl)
        } else {
          return $http({
            method: "GET",
            url: config.assetUrl + "/" + templateUrl,
            headers: {
              Authorization: undefined
            }
          }).then(function(res){
            var result = res.data;
            // Cache the result
            $templateCache.put(templateUrl, result);
            return result;
          });
        }
      };
    });
  });


clientDashboardApp.run(function (
  $rootScope,
  $window,
  $location,
  $state,
  configService,
  userService,
  uiSelectConfig,
) { //$state needs to be here to make ui-router work


  uiSelectConfig.spinnerEnabled = true;
  uiSelectConfig.spinnerClass = "fas fa-spinner fa-spin glyphicon"

  // Add underscore to views
  $rootScope._ = _;
  $rootScope.assetUrl = $window.assetUrl;

  // Watch routes to allow login
  $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams, options) {

    if (toState.redirectTo) {
      event.preventDefault();
      $state.go(toState.redirectTo, toParams, {location: 'replace'});
    }

  });


});

clientDashboardApp.config(function ($httpProvider, $uibTooltipProvider, $provide) {



  $httpProvider.interceptors.push('authInterceptor');
  $uibTooltipProvider.setTriggers({'initTutorial': 'initTutorial'});

  //initialize get if not there
  if (!$httpProvider.defaults.headers.get) {
    $httpProvider.defaults.headers.get = {};
  }

  //disable IE ajax request caching
  $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';

  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
  $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
});
